import { useState, useCallback, useEffect } from 'react'
import { RequestService } from '../services/RequestService'

const useUserPendingActions = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const { data } = await RequestService.getUserPendingActions()

      setData(data)
    } catch (e) {
      console.log('useUserPendingActions', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data, fetchData }
}

export default useUserPendingActions
